import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Divider,
  Collapse,
  IconButton,
} from "@mui/material";
import {
  Dashboard,
  ShoppingCart,
  Store,
  AddCircle,
  AttachMoney,
  AccountCircle,
  RateReview,
  BarChart,
  Settings,
  Label,
  ExpandLess,
  ExpandMore,
  Menu as MenuIcon, 
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom"; 
import { useMediaQuery, useTheme } from "@mui/material"; 
import sidelogo from "../../../assests/logo.svg fill.svg";

const Sidebar = () => {
  const [activeParent, setActiveParent] = useState(null); 
  const [activeChild, setActiveChild] = useState(null); 
  const [expandedIndex, setExpandedIndex] = useState(null); 
  const [drawerOpen, setDrawerOpen] = useState(false); 

  const navigate = useNavigate(); 

  const theme = useTheme(); 
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); 

  const menuItems = [
    { text: "Dashboard", icon: <Dashboard />, path: "/" },
    {
      text: "Products",
      icon: <ShoppingCart />,
      path: null,
      subItems: [
        { text: "Product List 1", path: "/products/productlist" },
        { text: "Product grid ", path: "/products/productgrid" },
        { text: "Product grid 2", path: "/products/productgrid2" },
        { text: "Categories", path: "/products/categories" },
      ],
    },
    {
      text: "Orders",
      icon: <Store />,
      path: null,
      subItems: [
        { text: "Order List 1", path: "/orders/orderlist" },
        { text: "Order List 2", path: "/orders/pending" },
        { text: "order deatils", path: "/orders/orderdetails" },
      ],
    },
    {
      text: "Sellers",
      icon: <Store />,
      path: null,
      subItems: [
        { text: "Seller Card", path: "/sellers/sellercards" },
        { text: "Seller List", path: "/sellers/sellerlist" },
        { text: "Seller Profile", path: "/sellers/sellerprofile" },
      ],
    },
    {
      text: "Add Product",
      icon: <AddCircle />,
      path: null,
      subItems: [
        { text: "Product List 1", path: "/addproduct/addproduct1" },
        { text: "Product List 2", path: "/addproduct/addproduct2" },
        { text: "Product List 3", path: "/addproduct/addproduct3" },
        { text: "Product List 4", path: "/addproduct/addproduct4" },

      ],
    },
    {
      text: "Transactions",
      icon: <AttachMoney />,
      path: null,
      subItems: [
        { text: "Trasaction 1", path: "/transactions/transaction1" },
        { text: "Transations 2", path: "/transactions/transations2" },
      ],
    },
    {
      text: "Account",
      icon: <AccountCircle />,
      path: null,
      subItems: [
        { text: "Profile", path: "/account/profile" },
        { text: "Settings", path: "/account/settings" },
      ],
    },
    { text: "Reviews", icon: <RateReview />, path: "/review" },
    { text: "Brands", icon: <BarChart />, path: "/brands" },
    { text: "Statistics", icon: <BarChart />, path: "/statistics" },
  ];

  const settingsItems = [
    { text: "Settings", icon: <Settings />, path: "/settings" },
    { text: "Starter Page", icon: <Label />, path: "/starter-page" },
  ];

  const handleParentClick = (index, item) => {
    setActiveParent(index); 
    setActiveChild(null); 
    setExpandedIndex(expandedIndex === index ? null : index); 

    if (item.path) {
      navigate(item.path);
    }
  };

  const handleChildClick = (parentIndex, childIndex, childItem) => {
    setActiveParent(parentIndex); 
    setActiveChild(`${parentIndex}-${childIndex}`); 
    if (childItem.path) {
      navigate(childItem.path); 
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
     
      {isMobile && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: "absolute",
            top: "10px",
            left: "10px",
            zIndex: 1300, 
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      <Drawer
        variant={isMobile ? "temporary" : "permanent"} 
        anchor="left"
        open={isMobile ? drawerOpen : true} 
        onClose={toggleDrawer}
        sx={{
          width: 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
          },
        }}
      >
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            <img
              src={sidelogo}
              alt="Nest Logo"
              style={{ marginRight: "10px" }}
            />
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Mart & Grocery
          </Typography>
        </Box>
        <Divider />
        <List>
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem
                button
                onClick={() => handleParentClick(index, item)}
                sx={{
                  backgroundColor:
                    activeParent === index ? "#eafaf1" : "transparent",
                  "&:hover": { backgroundColor: "#eafaf1" },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: activeParent === index ? "#3bb77e" : "inherit",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  sx={{
                    "& .MuiTypography-root": {
                      color: activeParent === index ? "#3bb77e" : "inherit",
                      fontWeight: activeParent === index ? "bold" : "normal",
                    },
                  }}
                />
                {item.subItems &&
                  (expandedIndex === index ? <ExpandLess /> : <ExpandMore />)}
              </ListItem>
              {item.subItems && (
                <Collapse
                  in={expandedIndex === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.subItems.map((subItem, subIndex) => (
                      <ListItem
                        button
                        key={`${index}-${subIndex}`}
                        onClick={() =>
                          handleChildClick(index, subIndex, subItem)
                        }
                        sx={{
                          pl: 6,
                          backgroundColor:
                            activeChild === `${index}-${subIndex}`
                              ? "#eafaf1"
                              : "transparent",
                          "&:hover": { backgroundColor: "#eafaf1" },
                        }}
                      >
                        <ListItemText
                          primary={subItem.text}
                          sx={{
                            "& .MuiTypography-root": {
                              color:
                                activeChild === `${index}-${subIndex}`
                                  ? "#3bb77e"
                                  : "inherit",
                              fontWeight:
                                activeChild === `${index}-${subIndex}`
                                  ? "bold"
                                  : "normal",
                            },
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
        <Divider />
        <List>
          {settingsItems.map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={() => handleParentClick(menuItems.length + index, item)}
              sx={{
                backgroundColor:
                  activeParent === menuItems.length + index
                    ? "#eafaf1"
                    : "transparent",
                "&:hover": { backgroundColor: "#eafaf1" },
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{
                  "& .MuiTypography-root": {
                    color:
                      activeParent === menuItems.length + index
                        ? "#3bb77e"
                        : "inherit",
                    fontWeight:
                      activeParent === menuItems.length + index
                        ? "bold"
                        : "normal",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Sidebar;

